import { css, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  background: ${theme.backgrounds.backgroundFour};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  box-shadow: ${theme.boxShadows.small};
  border-radius: 24px;
  padding: 22px;
  max-width: 698px;
  width: 100%;
  box-sizing: border-box;
  max-height: 90vh;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const title = (theme: Theme) => css`
  color: ${theme.colors.typographyTwo};
  font-size: 22px;
  font-weight: 700;
`

export const form = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(3)};
`

export const actions = (theme: Theme) => css`
  display: flex;
  gap: ${theme.spacing(2)};
`
